module.exports = __webpack_public_path__ + "static/media/13.e00b9a47.jpg";